<div class="container content-box module-content">
  <!-- Start Activity 7 -->
  <div id="activity1">
      <h3>Activity: Landlord or Tenant: Who is Responsible? </h3>
      <div class="radio wrapper">
          <!-- 1 -->
          <div class="question1">
              <br> <b> Your unit's hallway light bulb burns out.</b> <br>
              <input id="question1_1" name="question1" type="radio" [value]="true" [(ngModel)]="model7.model7_Q1" (click)="m7_Q1()"> <label for="question1_1">Tenant</label><br/>
              <input id="question1_2" name="question1" type="radio" [value]="false" [(ngModel)]="model7.model7_Q1" (click)="m7_Q1()"> <label for="question1_2">Landlord</label><br/>
              <div *ngIf="model7.model7_Q1 && model7_Q1" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;It is the landlord's responsibility to maintain common areas.
              </div>
              <div *ngIf="!model7.model7_Q1  && model7_Q1" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                  &nbsp;Correct!
              </div>
          </div>
          <!-- 2 -->
          <div class="question2">
              <br> <b>The light over your kitchen sink burns out.</b> <br>
              <input id="question2_1" name="question2" type="radio" [value]="false" [(ngModel)]="model7.model7_Q2" (click)="m7_Q2()"> <label for="question2_1">Tenant</label><br/>
              <input id="question2_2" name="question2" type="radio" [value]="true" [(ngModel)]="model7.model7_Q2" (click)="m7_Q2()"> <label for="question2_2">Landlord</label><br/>
              <div *ngIf="model7.model7_Q2 && model7_Q2" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;It is the tenant's responsibility to change light bulbs in his or her own unit.
              </div>
              <div *ngIf="!model7.model7_Q2  && model7_Q2" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                  &nbsp;Correct!
              </div>
          </div>

          <!-- 3 -->
          <div class="question3">
              <br> <b> Your front door lock does not work.</b> <br>
              <input id="question3_1" name="question3" type="radio" [value]="true" [(ngModel)]="model7.model7_Q3" (click)="m7_Q3()"> <label for="question3_1">Tenant</label><br/>
              <input id="question3_2" name="question3" type="radio" [value]="false" [(ngModel)]="model7.model7_Q3" (click)="m7_Q3()"> <label for="question3_2">Landlord</label><br/>
              <div *ngIf="model7.model7_Q3 && model7_Q3" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;It is the landlord's responsibility to maintain a unit to code. A lock that does not work is a safety issue and must be addressed immediately.
              </div>
              <div *ngIf="!model7.model7_Q3  && model7_Q3" style="background-color: rgba(0, 128, 0, 0.25); font-weight: bolder;">
                  &nbsp;Correct!
              </div>
          </div>

          <!-- 4 -->
          <div class="question4">
              <br> <b>You find bugs in the unit on the second day after moving into the unit. </b> <br>
              <input id="question4_1" name="question4" type="radio" [value]="false" [(ngModel)]="model7.model7_Q4" (click)="m7_Q4()"> <label for="question4_1">Tenant</label><br/>
              <input id="question4_2" name="question4" type="radio" [value]="true" [(ngModel)]="model7.model7_Q4" (click)="m7_Q4()"> <label for="question4_2">Landlord</label><br/>
              <div *ngIf="model7.model7_Q4 && model7_Q4" style="background-color: rgba(255,0,0,0.25);font-weight: bolder; font-size: 18px;">
                  &nbsp;You may have carried insects into the unit with your belongings. Cardboard boxes should be unpacked and disposed of immediately. Ask the landlord if the apartment was checked for pests and if there have been problems with pests.
              </div>
              <div *ngIf="!model7.model7_Q4  && model7_Q4" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                  &nbsp;Correct!
              </div>
          </div>

          <!-- 5 -->
          <div class="question5">
              <br> <b> Your child throws a ball through a windowpane.</b> <br>
              <input id="question5_1" name="question5" type="radio" [value]="false" [(ngModel)]="model7.model7_Q5" (click)="m7_Q5()"> <label for="question5_1">Tenant</label><br/>
              <input id="question5_2" name="question5" type="radio" [value]="true" [(ngModel)]="model7.model7_Q5" (click)="m7_Q5()"> <label for="question5_2">Landlord</label><br/>
              <div *ngIf="model7.model7_Q5 && model7_Q5" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;Any damage caused by children or guests is the tenant's responsibility.
              </div>
              <div *ngIf="!model7.model7_Q5  && model7_Q5" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                  &nbsp;Correct!
              </div>
          </div>

          <!-- 6 -->
          <div class="question6">
              <br> <b> There is no hot water. </b> <br>
              <input id="question6_1" name="question6" type="radio" [value]="true" [(ngModel)]="model7.model7_Q6" (click)="m7_Q6()"> <label for="question6_1">Tenant</label><br/>
              <input id="question6_2" name="question6" type="radio" [value]="false" [(ngModel)]="model7.model7_Q6" (click)="m7_Q6()"> <label for="question6_2">Landlord</label><br/>
              <div *ngIf="model7.model7_Q6 && model7_Q6" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;The landlord should address this problem immediately because it is a safety issue.
              </div>
              <div *ngIf="!model7.model7_Q6  && model7_Q6" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                  &nbsp;Correct!
              </div>
          </div>

          <!-- 7 -->
          <div class="question7">
              <br> <b> The bathroom exhaust fan is broken. </b> <br>
              <input id="question7_1" name="question7" type="radio" [value]="true" [(ngModel)]="model7.model7_Q7" (click)="m7_Q7()"> <label for="question7_1">Tenant</label><br/>
              <input id="question7_2" name="question7" type="radio" [value]="false" [(ngModel)]="model7.model7_Q7" (click)="m7_Q7()"> <label for="question7_2">Landlord</label><br/>
              <div *ngIf="model7.model7_Q7 && model7_Q7" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;Unless a Tenant misuses the exhaust fan, it is the landlord's responsibility to maintain the unit, including equipment and systems.
              </div>
              <div *ngIf="!model7.model7_Q7  && model7_Q7" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                  &nbsp;Correct!
              </div>
          </div>

          <!-- 8 -->
          <div class="question8">
              <br> <b> Replacing things that belong in the unit like window screens or light fixtures.</b> <br>
              <input id="question8_1" name="question8" type="radio" [value]="true" [(ngModel)]="model7.model7_Q8" (click)="m7_Q8()"> <label for="question8_1">Tenant</label><br/>
              <input id="question8_2" name="question8" type="radio" [value]="false" [(ngModel)]="model7.model7_Q8" (click)="m7_Q8()"> <label for="question8_2">Landlord</label><br/>
              <div *ngIf="model7.model7_Q8 && model7_Q8" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;You are not allowed to remove moveable pieces that belong with the unit.
              </div>
              <div *ngIf="!model7.model7_Q8  && model7_Q8" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                  &nbsp;Correct!
              </div>
          </div>

          <!-- 9 -->
          <div class="question9">
              <br> <b> Your sink drain is plugged.</b> <br>
              <input id="question9_1" name="question9" type="radio" [value]="false" [(ngModel)]="model7.model7_Q9" (click)="m7_Q9()"> <label for="question9_1">Tenant</label><br/>
              <input id="question9_2" name="question9" type="radio" [value]="true" [(ngModel)]="model7.model7_Q9" (click)="m7_Q9()"> <label for="question9_2">Landlord</label><br/>
              <div *ngIf="model7.model7_Q9 && model7_Q9" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;Many landlords will fix this type of problem; however, they also may charge you to do it. Try to safely unplug it yourself if you cannot call the landlord immediately. Avoid damaging the sink and pipes.
              </div>
              <div *ngIf="!model7.model7_Q9  && model7_Q9" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                  &nbsp;Correct!
              </div>
          </div>

          <!-- 10 -->
          <div class="question10">
              <br> <b> Making sure the rental condition checklist is completed when moving in.</b> <br>
              <input id="question10_1" name="question10" type="radio" [value]="false" [(ngModel)]="model7.model7_Q10" (click)="m7_Q10()"> <label for="question10_1">Tenant</label><br/>
              <input id="question10_2" name="question10" type="radio" [value]="true" [(ngModel)]="model7.model7_Q10" (click)="m7_Q10()"> <label for="question10_2">Landlord</label><br/>
              <div *ngIf="model7.model7_Q10 && model7_Q10" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;It is the tenant's responsibility and the tenant should keep a signed copy.
              </div>
              <div *ngIf="!model7.model7_Q10  && model7_Q10" style="background-color: rgba(0, 118, 0, 0.25);font-weight: bolder;">
                  &nbsp;Correct!
              </div>
          </div>

          <!-- 11 -->
          <div class="question11">
              <br> <b> Paying for normal wear and tear of the unit.</b> <br>
              <input id="question11_1" name="question11" type="radio" [value]="true" [(ngModel)]="model7.model7_Q11" (click)="m7_Q11()"> <label for="question11_1">Tenant</label><br/>
              <input id="question11_2" name="question11" type="radio" [value]="false" [(ngModel)]="model7.model7_Q11" (click)="m7_Q11()"> <label for="question11_2">Landlord</label><br/>
              <div *ngIf="model7.model7_Q11 && model7_Q11" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;Landlords should not deduct for normal wear and tear, including minor chipping and discoloration of paint.
              </div>
              <div *ngIf="!model7.model7_Q11  && model7_Q11" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                  &nbsp;Correct!
              </div>
          </div>
          <div *ngIf="flag" style="color:red" class="warning">
              You must answer all questions correctly before moving on
          </div>
      </div>
  </div>
</div>

<div class="container navigate-buttons">
  <button type="button" class="btn waves-dark w-25" (click)="goBack($event)"><i class="fas fa-angle-left mr-3"></i>{{backTitle}}</button>
  <button *ngIf="previewByAdmin || !delay || activityTwoCorrect()" type="button" class="btn waves-dark w-25" (click)="goNext($event) && resetFlag();">{{nextTitle}}<i class="fas fa-angle-right ml-3"></i></button>
  <button *ngIf="!(previewByAdmin || !delay || activityTwoCorrect())" type="button" class="btn waves-dark w-25" (click)="setFlag()" style="background-color: #ffd782;">{{nextTitle}}<i class="fas fa-angle-right ml-3"></i></button>
</div>
